import { TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../../locales/tokens";

export const LeaderboardTableHeader: FC = () => {
    const { t } = useTranslation();

    return (
        <TableHead>
            <TableRow>
                <TableCell align="center">
                    <Typography fontWeight={600} variant="body2">Ім'я</Typography>
                </TableCell>
                <TableCell align="center">
                    <Typography fontWeight={600} variant="body2">Кількість балів</Typography>
                </TableCell>
            </TableRow>
        </TableHead>
    )
};